export enum AntragsdatenSchluessel {
  NAVIGATION = 'NAVIGATION',
  DRAFT_BG = 'DRAFT_BG',
  DRAFT_HG = 'DRAFT_HG',
  DRAFT_KONTO = 'DRAFT_KONTO',
  DRAFT_EINKOMMEN = 'DRAFT_EINKOMMEN', // Dieser Eintrag ist überflüssig und wird nur für das Routing genutzt und das nur im Fehlerfall.
  DRAFT_EK_ARBEITSEINKOMMEN = 'DRAFT_EK_ARBEITSEINKOMMEN',
  DRAFT_EK_KINDERGELD = 'DRAFT_EK_KINDERGELD',
  DRAFT_EK_UNTERHALTSZAHLUNGEN = 'DRAFT_EK_UNTERHALTSZAHLUNGEN',
  DRAFT_EK_ARBEITSLOSENGELD = 'DRAFT_EK_ARBEITSLOSENGELD',
  DRAFT_EK_RENTE = 'DRAFT_EK_RENTE',
  DRAFT_EK_WEITERE_SOZIALLEISTUNGEN = 'DRAFT_EK_WEITERE_SOZIALLEISTUNGEN',
  DRAFT_EK_SONSTIGE_ENTGELTERSATZLEISTUNG = 'DRAFT_EK_SONSTIGE_ENTGELTERSATZLEISTUNG',
  DRAFT_EK_SONSTIGE_LAUFENDE_EINNAHMEN = 'DRAFT_EK_SONSTIGE_LAUFENDE_EINNAHMEN',
  DRAFT_EK_GEMEINNUETZIGE_TAETIGKEIT = 'DRAFT_EK_GEMEINNUETZIGE_TAETIGKEIT',
  DRAFT_EK_EINNAHMEN_AUS_VERMIETUNG = 'DRAFT_EK_EINNAHMEN_AUS_VERMIETUNG',
  DRAFT_EK_EINMALIGE_EINNAHMEN = 'DRAFT_EK_EINMALIGE_EINNAHMEN',
  DRAFT_EK_SACHBEZUEGE = 'DRAFT_EK_SACHBEZUEGE',
  DRAFT_EK_SELBSTAENDIGE_TAETIGKEIT = 'DRAFT_EK_SELBSTAENDIGE_TAETIGKEIT',
  DRAFT_EK_BAFOEG = 'DRAFT_EK_BAFOEG',
  DRAFT_KDU = 'DRAFT_KDU',
  DRAFT_ABSETZUNG = 'DRAFT_ABSETZUNG',
  DRAFT_WEITERE_AENDERUNGEN = 'DRAFT_WEITERE_AENDERUNGEN',
  DRAFT_BEWILLIGUNG_BISHERIGER_LEISTUNGEN = 'DRAFT_BEWILLIGUNG_BISHERIGER_LEISTUNGEN',
  DRAFT_UMZUG = 'DRAFT_UMZUG',
}
